import AirworthyControl from '../AirworthyControl';
import LastServiceLine from '../LastServiceLine';
import LifecycleControl from '../LifecycleControl';
import LifecycleLogLine from '../LifecycleLogLine';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneCardHeader: FunctionComponent<Props> = ({
    className = '',
    drone,
    isAdmin,
    onSetAirworthy,
    onSetLifecycle,
    showStatus,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const statusClass = styles[`status${drone.status}`] ?? '';
    const statusLabels = {
        caution: t.STATUS_CAUTION,
        critical: t.STATUS_CRITICAL,
        good: t.STATUS_GOOD
    };
    const readinessLabels = {
        grounded: t.READINESS_GROUNDED,
        hold: t.READINESS_HOLD,
        ready: t.READINESS_READY
    };

    return (
        <VerticalContainer className={`${styles.droneHeader} ${className}`} testId={testId}>
            <HorizontalContainer className={styles.droneHead}>
                <VerticalContainer className={styles.droneIdent}>
                    <Wrapper className={styles.droneName}>{drone.name}</Wrapper>

                    <Wrapper className={styles.droneSerial}>{drone.serial}</Wrapper>
                </VerticalContainer>

                <HorizontalContainer className={styles.dronePills}>
                    {showStatus && (
                        <Wrapper className={`${styles.pill} ${statusClass}`}>
                            <Wrapper className={styles.dot} />

                            {statusLabels[drone.status]}
                        </Wrapper>
                    )}

                    <AirworthyControl
                        droneId={drone.id}
                        isAdmin={isAdmin}
                        onSetAirworthy={onSetAirworthy}
                        readiness={drone.readiness}
                    />

                    <LifecycleControl
                        droneId={drone.id}
                        isAdmin={isAdmin}
                        onSetLifecycle={onSetLifecycle}
                        status={drone.lifecycleStatus}
                    />
                </HorizontalContainer>
            </HorizontalContainer>

            {drone.airworthyLog && (
                <Wrapper className={styles.airworthyLog}>
                    {t.AIRWORTHY_SET_BY({
                        status: readinessLabels[drone.airworthyLog.status],
                        when: new Date(drone.airworthyLog.at).toLocaleDateString(),
                        who: drone.airworthyLog.by
                    })}
                </Wrapper>
            )}

            {drone.lifecycleLog && <LifecycleLogLine log={drone.lifecycleLog} />}

            {drone.latestServiceRecord && <LastServiceLine record={drone.latestServiceRecord} />}
        </VerticalContainer>
    );
};

export default DroneCardHeader;
